import { useState, useEffect } from "react";
import { subscribeToView } from "@/services/viewService";
import { useAuthStore } from "@/store/authStore";
import type { View } from "@/types";

interface UseViewResult {
  view: View | null;
  loading: boolean;
  error: Error | null;
}

export function useView(viewId: string): UseViewResult {
  const [view, setView] = useState<View | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const user = useAuthStore((s) => s.user);

  useEffect(() => {
    if (!viewId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const unsubscribe = subscribeToView(
      viewId,
      (viewData) => {
        setView(viewData);
        setLoading(false);
      },
      (err) => {
        setError(err);
        setLoading(false);
      },
      user?.uid
    );

    return () => unsubscribe();
  }, [viewId, user?.uid]);

  return { view, loading, error };
}
